import React, { useEffect, useRef } from 'react';
import { LinkButton } from 'fronton-react';
import { SMALL_FALLBACK_PRODUCT_IMAGE_URL } from 'pages/common/components/Product/fallback-product-images.const';
import { gaImpressionsProduct } from 'ga-events/ga-impressions-product';
import { TComplimentaryProductInfo } from 'pages/dimensions/store/dimensions';
import { PriceAndCounterComponent } from '../PriceAndCounter/price-and-counter.component';
import {
  ComplimentaryProductImg,
  ComplimentaryProductInfoBlock,
  ComplimentaryProductInfoTitle,
} from '../styles';
import { Checkbox } from '../Checkbox';

type TComplementaryProductComponent = {
  product: TComplimentaryProductInfo;
  index: number;
  isDisabled: boolean;
};

export const ComplementaryProductComponent = ({
  product,
  index,
  isDisabled,
}: TComplementaryProductComponent) => {
  const productRef = useRef<HTMLDivElement>(null);

  const handleOpenProduct = () => {
    window.open(`/product/${product.product_page_name.value[0]}`);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          gaImpressionsProduct({
            name: product.displayedName.value[0],
            id: product.productId,
            price: `${product.salesPriceValueInConsumerUnitValue ?? 0}`,
            position: `${index + 2}`,
          });
        }
      },

      {
        threshold: 0.5,
      }
    );

    if (productRef.current) {
      observer.observe(productRef.current);
    }

    return () => {
      if (productRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(productRef.current);
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps -- Нужно послать только один раз
  }, []);

  return (
    <ComplimentaryProductInfoBlock ref={productRef}>
      <ComplimentaryProductInfoTitle>
        <Checkbox productId={product.productId} />
        <ComplimentaryProductImg
          onClick={handleOpenProduct}
          src={product?.mediaMainPhoto.value[0] || SMALL_FALLBACK_PRODUCT_IMAGE_URL}
          alt={product.displayedName.value[0]}
          loading="lazy"
          width={32}
          height={32}
        />
        <LinkButton
          disabled={isDisabled}
          style={{ cursor: 'pointer', textAlign: 'justify' }}
          size="m"
          variant="normal"
          onClick={handleOpenProduct}>
          {product.displayedName.value[0]}
        </LinkButton>
      </ComplimentaryProductInfoTitle>
      <PriceAndCounterComponent product={product} />
    </ComplimentaryProductInfoBlock>
  );
};
